export default {
    okText: '确定',
    cancelText: '取消',
};
